const host = {
  dev: 'https://pocket-api.51yestech.com',
  // dev: 'https://api.kday123.com',
  prod: 'https://api.kday123.com',
  ws: 'wss://pocket-api.51yestech.com',
  wsProd: 'wss://api.kday123.com',
};
module.exports = host;
